import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
} from "@mui/material";

interface InsufficientBalanceModalProps {
  open: boolean;
  onClose: () => void;
}

const InsufficientBalanceModal: React.FC<InsufficientBalanceModalProps> = ({
  open,
  onClose,
}) => {
  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle className="fw-bold">Insufficient Balance</DialogTitle>
      <DialogContent style={{marginTop:'-18px'}}>
        You do not have sufficient balance to make this transaction. <br />
        Please recharge your wallet before making the booking.
      </DialogContent>
      <DialogActions className="d-flex justify-content-center">
        <Button onClick={onClose} style={{backgroundColor:"#022f40"}} variant="contained">
          OK
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default InsufficientBalanceModal;
